import React, { Suspense, lazy } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/jquery/dist/jquery.min.js';
// import '../node_modules/get-google-fonts/fonts/fonts.css';
// import '../node_modules/aos/dist/aos.css';
// import '../node_modules/aos/dist/aos.js';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import './css/fontawesome-free-5.11.2-web/css/all.css'
import './index.css';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { usePageTracking } from './ga4Events.js';

const App = lazy(() => import('./App'));
const Header = lazy(() => import('./header.js'));
const Color = lazy(() => import('./color_bg.js'));
const About_Us_Inner = lazy(() => import('./about_us_pages/about_us_inner.js'));
const Our_Service_Inner = lazy(() => import('./our_service_page/our_service_inner.js'));
const Our_Service_Inner_Connect = lazy(() => import('./our-service.js'));
const About_Us = lazy(() => import('./about-us.js'));
const Our_work_Inner_Connect = lazy(() => import('./our-work.js'));
const Contact_us_inner_connect = lazy(() => import('./contact-us.js'));
const Popup_contact = lazy(() => import('./contact_us_page/thankyou.js'));
const PageNotFound = lazy(() => import('./notfoundpage.js'));
const Blogs = lazy(() => import('./blogs.js'));
const Blogs1 = lazy(() => import('./blogs1.js'));
const Blogs2 = lazy(() => import('./blogs2.js'));
const Blogs3 = lazy(() => import('./blogs3.js'));
const Blogs4 = lazy(() => import('./blogs4.js'));
const Blogs5 = lazy(() => import('./blogs5.js'));
const Blogs6 = lazy(() => import('./blogs6.js'));
const Blogs7 = lazy(() => import('./blogs7.js'));
const Blogs8 = lazy(() => import('./blogs8.js'));
const Blogs9 = lazy(() => import('./blogs9'));
const Blogsten = lazy(() => import('./blogs10'));
const Blogs11 = lazy(() => import('./blogs11.js'));
const Blogs12 = lazy(() => import('./blogs12.js'));
const Webdesign_and_developments = lazy(() => import('./our_service_drop/web-design'));
const Mobile_and_developments = lazy(() => import('./our_service_drop/mobile_apps_drop'));
const Ourniche_and_developments = lazy(() => import('./our_service_drop/our_niche'));
const DigitalAndDevelopments = lazy(() => import('./our_service_drop/digital_mark'));
const Mobile_and_Aus = lazy(() => import('./our_service_drop/mobile_aus'));
const Web_and_Aus = lazy(() => import('./our_service_drop/web_aus'));
const Career = lazy(() => import('./careers.js'));
const Web_developement_landing = lazy(() => import('./landing_page/web_developement'));
const Mobile_app_Development = lazy(() => import('./landing_page/mobile_development'));
const Blogs13 = lazy(() => import('./blogs13.js'));
const Blogs14 = lazy(() => import('./blogs14.js'));
const CommonDevelopmentMistakes = lazy(() => import('./common-developement-mistake-blogs.js'));

const RouterWithTracking = () => {
    usePageTracking();

    return (
        <Suspense fallback={<div className="text-center p-5">...</div>}>
            <Routes>
                <Route exact path='/' element={<App />} />
                <Route path="/header" element={<Header />} />
                <Route path="/about-Us" element={<About_Us />} />
                <Route path="/color_bg" element={<Color />} />
                <Route path="/our-work" element={<Our_work_Inner_Connect />} />
                <Route path="/our-service" element={<Our_Service_Inner_Connect />} />
                <Route path="/contact-us" element={<Contact_us_inner_connect />} />
                <Route path="/thankyou" element={<Popup_contact />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/web-application-development-using-java" element={<Blogs1 />} />
                <Route path="/blogs/mobile-application-development-using-ionic-framework" element={<Blogs2 />} />
                <Route path="/blogs/definition-of-augmented-reality-and-how-does-it-work" element={<Blogs3 />} />
                <Route path="/blogs/how-can-the-best-UX-UI-designs-influence-your-business" element={<Blogs4 />} />
                <Route path="/blogs/how-a-taxi-booking-app-can-improve-your-business" element={<Blogs5 />} />
                <Route path="/blogs/the-definition-of-online-reputation-management" element={<Blogs6 />} />
                <Route path="/blogs/differences-between-UX-and-UI-design" element={<Blogs7 />} />
                <Route path="/blogs/how-to-preserve-your-brand-online-in-2020-with-reputation-management-software" element={<Blogs8 />} />
                <Route path="/blogs/the-most-trending-technology-stacks-of-the-year" element={<Blogs9 />} />
                <Route path="/blogs/the-importance-of-quality-assurance-and-testing-in-software-development" element={<Blogsten />} />
                <Route path="/blogs/E-Commerce-Augmented-Reality-App-in-Texas" element={<Blogs11 />} />
                <Route path="/blogs/how-to-protect-WordPress-website-from-hackers" element={<Blogs12 />} />
                <Route path="/blogs/how-to-make-your-WordPress-URL-SEO-Friendly" element={<Blogs13 />} />
                <Route path="/blogs/10-Ways-to-Speed-up-WordPress-Performance" element={<Blogs14 />} />
                <Route path="/web-application-development" element={<Webdesign_and_developments />} />
                <Route path="/mobile-application-development" element={<Mobile_and_developments />} />
                <Route path="/our-niche" element={<Ourniche_and_developments />} />
                <Route path="/digital-marketing" element={<DigitalAndDevelopments />} />
                <Route path="/careers" element={<Career />} />
                <Route path="/web-application-development" element={<Web_developement_landing />} />
                <Route path="/mobile-application-development" element={<Mobile_app_Development />} />
                <Route path="/development-commom-mistakes" element={<CommonDevelopmentMistakes />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </Suspense>
    );
};

export default RouterWithTracking;